/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { IAbsent, IRequestingReschedule } from 'types/IRequestingReschedule';
import httpClient from 'utils/httpClient';

export const REQUESTING_RESCHEDULE = (unitId: number) =>
  `/v2/teacher/change-schedule/${unitId}`;

export type Response = {
  unit: IAbsent;
  requestSchedule: IRequestingReschedule[];
  responsiveSchedule: string;
};

export type Params = {
  unitId: number;
};

export const retrieveRequestingReschedule = ({ unitId }: Params) => {
  return httpClient.get<Response>(REQUESTING_RESCHEDULE(unitId), {});
};

export const useRetrieveRequestingReschedule = (
  params: Params,
  opts?: UseQueryOptions<AxiosResponse<Response>, AxiosError<any>>,
) => {
  return useQuery<AxiosResponse<Response>, AxiosError<any>>(
    [REQUESTING_RESCHEDULE(params.unitId)],
    () => retrieveRequestingReschedule(params),
    { retry: true, ...opts },
  );
};
